import { merge } from 'ramda';
import { SUCCESS, REQUEST, FAIL } from 'src/store/actions/worksInDepartmentsActions';

const initialState = {
  data: {},
  fetching: false,
  errors: []
};

const worksInDepartments = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true });
    case SUCCESS:
      return merge(state, { data: action.worksInDepartments, fetching: false, errors: [] });
    case FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    default:
      return state;
  }
};

export default worksInDepartments;
